import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "messenger--sprite",
  "use": "messenger--sprite-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"messenger--sprite\">\n    <path d=\"M0 11.111C0 14.607 1.744 17.726 4.471 19.763V24L8.557 21.758C9.647 22.059 10.802 22.223 11.999 22.223C18.626 22.223 23.999 17.249 23.999 11.112C24 4.975 18.627 0 12 0C5.373 0 0 4.974 0 11.111H0ZM10.734 7.999L13.864 11.258L19.751 7.999L13.191 14.961L10.136 11.703L4.173 14.962L10.734 7.999Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol